export default __webpack_public_path__ + "d1e8b637b2cdd5d933a5755b8f92c38d.svg";